import { DynamicLink, SectionWrapper, Typography } from '../shared';

type buttonItem = {
  buttonLink: string;
  buttonText: string;
};

type bgImageItem = {
  title: string
  url: string;
};

type ContactProps = {
  title?: string;
  buttonData?: buttonItem;
  buttonText?: string;
  bgImage?: bgImageItem;
};

const Contact = ({ title, buttonData, buttonText }: ContactProps) => {
  return (
  <></>
  );
};

export default Contact;
